import React from 'react';

import { flagStyles } from '../settings';

const SvgAT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-240px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAT;
